import Plyr from 'plyr'

const cVideo = () => {
  const block = document.querySelector('.video__container')
  const playerBlock = block?.querySelector('.video__content')
  const playButton = block?.querySelector('.video__play')
  const closeButton = block?.querySelector('.video__close')
  const controlsButton = block?.querySelector('.video__controls')

  const player = new Plyr('.video__player', {
    controls: ['play', 'progress'],
    clickToPlay: false,
    fullscreen: {
      enabled: false,
    },
    iconPrefix: `<svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="32" cy="32.5312" r="32" fill="white"/></svg>`,
  })

  function togglePlaying() {
    const plyrBlock = document.querySelector('.plyr--video')
    playerBlock.setAttribute(`style`, `height: ${playerBlock.clientHeight}px`)
    plyrBlock.classList.toggle('is-open')
    playerBlock.classList.toggle('is-play')

    if (player.playing) {
      player.stop()
    } else {
      player.play()
    }

    changeButton()
  }

  function changeButton() {
    controlsButton.innerHTML = player.playing
      ? '<svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"> <circle cx="32" cy="32.5312" r="32" fill="white"/> <path d="M39.4665 23.1967V41.8634C39.4665 42.3585 39.3235 42.8333 39.0689 43.1833C38.8143 43.5334 38.469 43.7301 38.109 43.7301H35.0544C34.6944 43.7301 34.3491 43.5334 34.0945 43.1833C33.8399 42.8333 33.6968 42.3585 33.6968 41.8634V23.1967C33.6968 22.7017 33.8399 22.2269 34.0945 21.8768C34.3491 21.5267 34.6944 21.3301 35.0544 21.3301H38.109C38.469 21.3301 38.8143 21.5267 39.0689 21.8768C39.3235 22.2269 39.4665 22.7017 39.4665 23.1967ZM28.9453 21.3301H25.8908C25.5307 21.3301 25.1854 21.5267 24.9308 21.8768C24.6762 22.2269 24.5332 22.7017 24.5332 23.1967V41.8634C24.5332 42.3585 24.6762 42.8333 24.9308 43.1833C25.1854 43.5334 25.5307 43.7301 25.8908 43.7301H28.9453C29.3054 43.7301 29.6507 43.5334 29.9053 43.1833C30.1599 42.8333 30.3029 42.3585 30.3029 41.8634V23.1967C30.3029 22.7017 30.1599 22.2269 29.9053 21.8768C29.6507 21.5267 29.3054 21.3301 28.9453 21.3301Z" fill="currentColor"/> </svg>'
      : '<svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg"><circle r="32" transform="matrix(1 0 0 -1 32 32.9297)" fill="white"/><path d="M44.1682 34.5286L27.3682 44.7836C27.0884 44.9609 26.7652 45.058 26.4339 45.0641C26.1027 45.0703 25.7761 44.9854 25.4899 44.8186C25.1994 44.6592 24.9572 44.4245 24.7889 44.1391C24.6205 43.8537 24.5322 43.5282 24.5332 43.1969V22.6636C24.5322 22.3322 24.6205 22.0068 24.7889 21.7214C24.9572 21.436 25.1994 21.2013 25.4899 21.0419C25.7761 20.8751 26.1027 20.7902 26.4339 20.7964C26.7652 20.8025 27.0884 20.8996 27.3682 21.0769L44.1682 31.3319C44.4436 31.498 44.6713 31.7325 44.8294 32.0125C44.9876 32.2925 45.0706 32.6087 45.0706 32.9302C45.0706 33.2518 44.9876 33.568 44.8294 33.848C44.6713 34.128 44.4436 34.3625 44.1682 34.5286Z" fill="currentColor"/></svg>'
  }

  if (closeButton) {
    closeButton.addEventListener('click', () => {
      togglePlaying()
      player.stop()
    })
  }

  if (playButton) {
    playButton.addEventListener('click', () => {
      togglePlaying()
    })
  }

  if (controlsButton) {
    controlsButton.addEventListener('click', () => {
      if (player.playing) {
        player.pause()
        changeButton()
      } else {
        player.play()
        changeButton()
      }
    })
  }


  if (block) {
    block.addEventListener('click', (e) => {
      if (playerBlock) {
        const plyrBlock = document.querySelector('.plyr--video')
      }
    })
  }
}

export default cVideo
